import Vue from "vue";

import "@/telescope/components/global";

Vue.component("topHeader", require("./topHeader").default);
